const CONSENT_KEY = "gt_cookie_consent";
const TOKEN_KEY = "gt_xsell_token";

const hasFullConsent = () => {
  try {
    return localStorage.getItem(CONSENT_KEY) === "all";
  } catch {
    return false;
  }
};

export const getCrossSellToken = () => {
  if (!hasFullConsent()) return null;
  try {
    let t = localStorage.getItem(TOKEN_KEY);
    if (!t) {
      t = (crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2)}`);
      localStorage.setItem(TOKEN_KEY, t);
    }
    return t;
  } catch {
    return null;
  }
};

const post = (path, payload) => {
  try {
    fetch(`${process.env.REACT_APP_BACKEND_URL}${path}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
      keepalive: true,
    }).catch(() => {});
  } catch { /* tracking must never block the buyer */ }
};

export const trackCrossSellClick = (sourceEventId, targetEventId, placement) => {
  if (!sourceEventId || !targetEventId) return;
  post("/api/public/crosssell-click", {
    source_event_id: sourceEventId,
    target_event_id: targetEventId,
    placement,
    session_token: getCrossSellToken(),
  });
};

export const trackWaitlistEmailArrival = (sourceSlug, targetEventId) => {
  if (!sourceSlug || !targetEventId) return;
  try {
    const guard = `gt_xsell_we_${targetEventId}`;
    if (sessionStorage.getItem(guard)) return;
    sessionStorage.setItem(guard, "1");
  } catch { /* fall through — server dedupe still applies */ }
  post("/api/public/crosssell-click", {
    source_event_slug: sourceSlug,
    target_event_id: targetEventId,
    placement: "waitlist_email",
    session_token: getCrossSellToken(),
  });
};

export const pingCrossSellConversion = (orderId) => {
  const token = hasFullConsent() ? getCrossSellToken() : null;
  if (!token || !orderId) return;
  post("/api/public/crosssell-convert", { session_token: token, order_id: orderId });
};
